import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate, useOutletContext } from 'react-router-dom';
//api
import { deleteList } from 'api/lists';
import { getAllLists } from 'api/pathForHook/lists';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//context
import { usePermissions } from 'components/backoffice/PermissionsContext';
//components
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import Button from 'components/backoffice/buttonCustom';
import Title from 'components/backoffice/texts/title';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import FiltersTableLists from './FiltersTableLists';
import StatusBudget from 'components/budget/StatusBudget';

const Lists = () => {
  const userPermissions = usePermissions();
  const navigate = useNavigate();
  const [lists, setLists] = useState([]);
  const [list, setList] = useState({});
  const [formFilter, setFormFilter] = useState({
    nombre: '',
    tipo: '',
  });
  const [noResults, setNoResults] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [responseInfo, setResponseInfo] = useState({});
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()

  const colsLists = [t('lista'), t('titulo'), t('faqs.order'), t('state'), t('tipo'), t('contenido'), t('location'), t('actions')];

  const { fetchData, stateData, loading } = useHandleSearch();

  const getLists = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        nombre: formFilter.nombre || '',
        tipo: formFilter.tipo || '',
        fields: 'id,nombre,estado,tipo,contenido,location_web,order',
        order_by: 'order'
      }
      await fetchData(getAllLists(), payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTitle(t('listas'))
    return () => {
      setTitle(''); 
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, noResults, totalPages } = stateData;
    if (results !== null) {
      setLists(results);
      setResponseInfo({ errors, noResults, totalPages })
    } else {
      setLists(null);
      setResponseInfo({ errors })
    }
  }, [stateData])


  useEffect(() => {
    getLists();
  }, [page, formFilter]);


  const onDelete = async () => {
    const { status } = await deleteList(list.id);
    if (status === 204) {
      toast.success(t('eliminadocorrectamente'));
      setFormFilter({
        nombre: '',
        tipo: '',
      });
      setShowDeleteModal(false);
    } else {
      toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
    }
  };

  const openModalDelete = (object) => {
    setShowDeleteModal(true);
    setList(object);
  };

  const handleClear = () => {
    setFormFilter({
      nombre: '',
      tipo: '',
    });
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
  };

  const handleCreate = () => {
    navigate('/intranet/lists/create');
  };

  const handleEdit = (id) => {
    navigate(`/intranet/lists/edit/${id}`);
  };

  const serializerStatus = (state) => {
    if (!state) {
      return 'danger';
    } else if (state) {
      return 'success';
    }
    return 'info';
  };

  return (
    <div className="d-lg-grid">
      <Title text={t('listas')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={9} xs={12} className="d-flex text-start">
          <FiltersTableLists
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            handleClear={handleClear}
            t={t}
            page={page}
            setPage={setPage}
          />
        </Col>
        <Col md={3} xs={12} className="d-flex text-end align-bottom p-md-0 justify-content-end pt-5 pt-md-0">
          {userPermissions.includes('lista.__add') && (
            <Button color="primary" onClick={handleCreate} extraClass={'mt-1'}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsLists}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {lists?.map((list) => (
            <tr key={list.id}>
              <td className="text-light">{`#${list.id}`}</td>
              <td className="text-light">{list.nombre}</td>
              <td className="text-light">{list.order ?? '-'}</td>
              <td className="text-light">
                <div className="d-flex justify-content-center">
                  <StatusBudget
                    text={!list.estado ? 'Inactive' : 'Active'}
                    status={serializerStatus(list.estado)}
                  />
                </div>
              </td>
              <td className="text-light">{list.tipo}</td>
              <td className="text-light">{list.contenido}</td>
              <td className="text-light">{list.location_web}</td>
              <td className="text-light item-dropdown text-end">
                <DropdownIcons
                  idItem={list.id}
                  handleDelete={userPermissions.includes('lista.__delete') && (() => openModalDelete(list))}
                  handleEdit={userPermissions.includes('lista.__modify') && (() => handleEdit(list.id))}
                />
              </td>
            </tr>
          ))}
        </CustomTable>
      </div>
      <DeleteModalCustom
        name={list?.nombre}
        openModal={showDeleteModal}
        setOpenModal={setShowDeleteModal}
        handleDelete={onDelete}
        deleteTitle={t('deletelist')}
        beforeTitle={t('listas')}
      />
    </div>
  );
};

export default Lists;
